import React from 'react'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import useNotification from './useNotification'
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles'
import {
    ClickAwayListener,
    Divider,
    Grid,
    Grow,
    IconButton,
    ListSubheader,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Typography,
} from '@material-ui/core'
import Badge from '@material-ui/core/Badge'
import BellIcon from '@material-ui/icons/Notifications'
import useTranslate from '../../../../i18n/useTranslate'
import ClearIcon from '@material-ui/icons/Clear'
import Tooltip from '../../../../control/tooltip/tooltip'

type NotificationView = NotificationType & ReturnType<typeof useNotification>
const NotificationView: React.FC<NotificationView> = (props) => {
    const { notiInfoList, openNotiList, anchorRef, onClickList, onclickClose, onclickToggle, onclickDeleteNoti } = props
    const classes = useStyles()
    const theme = useTheme()
    const translate = useTranslate()

    const StyledBadge = withStyles((theme) => ({
        badge: {
            right: -3,
            top: 13,
            border: `2px solid ${theme.palette.background.paper}`,
            padding: '0 4px',
        },
    }))(Badge)

    const getDisplayNotiTitle = () => {
        let title = 'การแจ้งเตือน'
        // const titleEN = 'Notification'

        if (translate.languageStore.currentLanguage === translate.languageKey.th) {
            title = 'การแจ้งเตือน'
        } else {
            title = 'Notification'
        }
        return title
    }
    const getNotificationCount = () => {
        let notiCount: number = 0
        notiInfoList?.forEach((itm) => {
            if (!itm.isWatched) {
                notiCount += 1
            }
        })

        return notiCount
    }

    return (
        <Grid>
            {' '}
            <Tooltip title={translate.get('LABEL.NOTIFICATION')}>
                <IconButton
                    size="small"
                    ref={anchorRef}
                    aria-controls={openNotiList ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={onclickToggle}
                >
                    <StyledBadge badgeContent={getNotificationCount()} color="secondary">
                        <BellIcon style={{ fontSize: '30px' }} />
                    </StyledBadge>
                </IconButton>
            </Tooltip>
            <Popper
                style={{ zIndex: 999 }}
                open={openNotiList}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper style={{ maxHeight: '600px', overflowY: 'auto' }}>
                            <ClickAwayListener onClickAway={onclickClose}>
                                <MenuList
                                    autoFocusItem={openNotiList}
                                    id="menu-list-grow"
                                    // onKeyDown={handleListKeyDown}
                                    subheader={
                                        <ListSubheader
                                            style={{ backgroundColor: 'white' }}
                                            component="div"
                                            id="nested-list-subheader"
                                        >
                                            <Typography
                                                align={'center'}
                                                variant={'body1'}
                                                style={{ fontWeight: 'bold', padding: '10px ' }}
                                            >
                                                {getDisplayNotiTitle()}
                                            </Typography>
                                        </ListSubheader>
                                    }
                                    onKeyDown={() => {}}
                                >
                                    {notiInfoList &&
                                        notiInfoList.length > 0 &&
                                        notiInfoList.map((itm) => {
                                            let displayProject = ''
                                            if (itm?.projectNumber) {
                                                if (
                                                    translate.languageStore.currentLanguage === translate.languageKey.th
                                                ) {
                                                    displayProject = `โครงการเลขที่ ${itm.projectNumber}`
                                                } else {
                                                    displayProject = `Project Number ${itm.projectNumber}`
                                                }
                                            } else {
                                                displayProject = itm.projectNameTH
                                                if (
                                                    translate.languageStore.currentLanguage === translate.languageKey.th
                                                ) {
                                                    displayProject = `ชื่อโครงการ ${itm.projectNameTH}`
                                                } else {
                                                    displayProject = `Project Name ${itm.projectNameEN}`
                                                }
                                            }

                                            return (
                                                <>
                                                    <Divider />
                                                    <MenuItem
                                                        className={
                                                            itm.isWatched ? classes.menuItemWatched : classes.menuItem
                                                        }
                                                        onClick={onClickList(itm)}
                                                    >
                                                        <Grid container>
                                                            <Grid
                                                                container
                                                                item
                                                                xs={2}
                                                                alignItems="center"
                                                                justify={'center'}
                                                            >
                                                                {!itm.isWatched && (
                                                                    <Paper
                                                                        variant="outlined"
                                                                        className={classes.paperProjectStatusMobile}
                                                                        style={{ background: `#2d98de` }}
                                                                    ></Paper>
                                                                )}
                                                            </Grid>
                                                            <Grid
                                                                // container
                                                                item
                                                                xs={8}
                                                                alignItems="center"
                                                            >
                                                                {/* {`Project Number ${itm.projectNumber}`} */}
                                                                <Typography variant={'body2'}>
                                                                    <section>
                                                                        <div
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                            }}
                                                                        >
                                                                            {displayProject}
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                paddingTop: '5px',
                                                                            }}
                                                                        >
                                                                            {translate.languageStore.currentLanguage ===
                                                                            translate.languageKey.th
                                                                                ? itm.notifyMessageTH
                                                                                : itm.notifyMessageEN}
                                                                        </div>
                                                                    </section>
                                                                </Typography>
                                                            </Grid>

                                                            <Grid
                                                                container
                                                                item
                                                                xs={2}
                                                                alignItems="center"
                                                                justify={'center'}
                                                            >
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={onclickDeleteNoti(itm)}
                                                                >
                                                                    <ClearIcon
                                                                        style={{ fontSize: '20px', color: '#b5c4d2' }}
                                                                    />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </MenuItem>
                                                </>
                                            )
                                        })}

                                    {!notiInfoList ||
                                        (notiInfoList.length === 0 && (
                                            <>
                                                <Divider />

                                                <Grid
                                                    container
                                                    item
                                                    xs={12}
                                                    alignItems="center"
                                                    justify={'center'}
                                                    className={classes.notiNotfound}
                                                >
                                                    {translate.languageStore.currentLanguage ===
                                                    translate.languageKey.th
                                                        ? `ไม่พบการแจ้งเตือน`
                                                        : `No notification`}
                                                </Grid>
                                            </>
                                        ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Grid>
    )
}

export type NotificationType = {
    // projectMode: 'CREATE' | 'EDIT'
    // callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
}
const Notification: React.FC<NotificationType> = (props) => {
    const useNotificationModel = useNotification(props)
    return <NotificationView {...props} {...useNotificationModel} />
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    menuItem: {
        padding: '20px',
        width: '385px',
        backgroundColor: '#f3f9fd8c',
    },

    menuItemWatched: {
        padding: '20px',
        width: '385px',
        backgroundColor: 'white',
    },
    paperProjectStatusMobile: {
        // padding: '10px',
        height: '10px',
        width: '10px',
        borderRadius: '20px',
    },
    notiNotfound: {
        padding: '20px',
        width: '385px',
        backgroundColor: 'white',
        color: '#bdbdbd',
    },
}))

export default Notification
